module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pricing/pricing.component.sass
// module id = ./src/app/pages/pricing/pricing.component.sass
// module chunks = main